import Utils from "Sources/utils/utils";
import SessionMaterial from "../components/session-material";

class SessionModel
{
  constructor(session) {
    this.extraMaterialList = session.extraMaterialList;
    this.gameSessionState = session.gameSessionState;
    this.materialList = session.materialList;
    this.missionList = session.missionList;
    this.sessionGroupList = session.sessionGroupList;
    this.studentList = session.studentList;
  }

  getMissionMaterials(missionKey)
  {
    let materials = [];
    let mission = this.getMission(missionKey);
    if (Utils.isNull(mission))
    {
      console.error("No mission found for key '" + missionKey + "'.");
      return materials;
    }

    mission.missionMaterialList.forEach(missionMaterial => {
      let material = this.getMaterial(missionMaterial.materialKey);
      if (Utils.isNull(material))
      {
        console.error("No material found for key '" + missionMaterial.materialKey + "'.");
      }
      else
      {
        materials.push(material);
      }
    });

    return materials;
  }

  getSessionGroupInventory(sessionGroupKey)
  {
    let inventory = null;
    //console.log(this.gameSessionState.inventoryList)
    //console.log(this.gameSessionState)


    this.gameSessionState.inventoryList.forEach(inv => {
      if (inv.sessionGroupKey === sessionGroupKey)
      {
        inventory = inv;
      }
    });

    return inventory;
  }

  getSessionMaterialForMaterialKey(materialKey)
  {
    let returnObj = null;
    this.gameSessionState.sessionMaterialList.forEach(sessionMaterial => {
      if (Utils.isNotNull(sessionMaterial.materialKey) && sessionMaterial.materialKey === materialKey)
      {
        returnObj = sessionMaterial;
      }
    });

    return returnObj;
  }

  getSessionMaterial(sessionMaterialKey)
  {
    let materialToReturn = null;
    this.gameSessionState.sessionMaterialList.forEach(sessionMaterial => {
      if (sessionMaterial.key === sessionMaterialKey)
      {
        materialToReturn = sessionMaterial;
      }
    });

    return materialToReturn;
  }

  getMaterial(materialKey)
  {
    let materialToReturn = null;

    this.materialList.forEach(material => {
      if (material.key === materialKey)
      {
        materialToReturn = material;
      }
    });

    return materialToReturn;
  }

  getMission(missionKey)
  {
    let returnObj = null;

    this.missionList.forEach(mission => {
      if (mission.key === missionKey)
      {
        returnObj = mission;
      }
    });

    return returnObj;
  }
}

export default SessionModel;



// WEBPACK FOOTER //
// ./app/js/models/session-model.js